import { Link } from 'react-router-dom';
import moment from 'moment';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ICONS, PATHS, IntroContent, USER_ROLES } from '../../common/constants';
import { selectServiceRequestFormIsVisible } from '../../store/selectors/serviceRequestForm';
import { setServiceRequestFormIsVisible } from '../../store/actions/serviceRequestForm';
import { selectSearch } from '../../store/selectors/search';
import Actions from '../Actions';
import Button from '../Button';
import Empty from '../Empty';
import IcoMoon from '../IcoMoon';
import Icon from '../Icon';
import Label from '../Label';
import Overlay from '../Overlay';
import Search from '../Search';
import ServiceRequestForm from '../ServiceRequestForm/ServiceRequestForm';
import Status from '../Status';
import GroupingTable from '../GroupingTable';
import { selectServiceRequests } from '../../store/selectors/serviceRequests';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectLoader } from '../../store/selectors/loader';
import { CSVDownload } from 'react-csv';

import { serviceRequestCsvHeaders as headers } from '../../services/csv/serviceRequestCsvHeaders';

import InfiniteScroll from 'react-infinite-scroll-component';
import {
  updateBulkStatus,
  createServiceRequestByGroup,
  fetchfilteredServiceRequestByStatusAndDays,
  fetchGroupServiceRequest,
} from '../../store/actions/serviceRequests';
import {
  clearServiceRequestByGroup,
  deleteServiceRequestFromGroup,
  deleteServiceRequestGroup,
  setCurrentGroupServiceRequestIndex,
  setDisplayClosedAndResolvedTickets,
} from '../../store/actions/serviceRequestsByGroup';
import { addFilterQuery } from '../../store/actions/Filter';
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import Checkbox from '../Checkbox';
import './serviceRequestsTable.scss';
import classNames from 'classnames';
import Popup from '../../pages/ServiceRequest/Popup';
import { Popup as Modal } from 'reactjs-popup';
import { Filters as FilterModal } from './Filters';
import { selectProperties } from '../../store/selectors/properties';
import { selectItems } from '../../store/selectors/items';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  getBuildingLevels,
  getPropertyBuildings,
} from '../../store/actions/buildings';
import ServiceRequestAssignForm from '../../pages/ServiceRequest/ServiceRequestAssignForm';
import { serviceRequestTableLocalTime } from '../../helpers/validationHelper';
import {
  clearLoadingDownloadServiceRequestList,
  fetchSelectedServiceRequestCSVExportDownloadList,
  fetchSelectedServiceRequestPDFExportDownloadList,
} from '../../store/actions/csvExport';
import { fetchPropertySuites, clearSuites } from '../../store/actions/suites';
import { selectSuites } from '../../store/selectors/suites';
import { variables } from '../../Tenants';
import Input from '../Input';
import {
  fetchAllIssueTypes,
  fetchAllTicketStatus,
} from '../../store/actions/formOptions';
import ContentBlock from '../ContentBlock';
import {
  fetchPropertyCommonAreas,
  clearSelectedPropertyCommonAreas,
  selectPropertyCommonAreasForFilterDone,
} from '../../store/actions/properties';
import { exitServiceRequestForm } from '../../store/actions/serviceRequestForm';
import { suiteName, commonAreaName, sortableType } from './transformations';
import { sortByDate } from '../Table/sorting';

let statuses = [
  { label: 'Submitted', key: 'Submitted' },
  { label: 'Scheduled', key: 'Scheduled' },
  { label: 'En Route', key: 'En Route' },
  { label: 'On Hold', key: 'On Hold' },
  { label: 'In Progress', key: 'In Progress' },
  { label: 'Resolved', key: 'Resolved' },
  { label: 'Declined', key: 'Declined' },
  { label: 'Closed', key: 'Closed' },
  { label: 'Archive', key: 'Archive' },
  { label: 'Assigned', key: 'Assigned' },
  { label: 'Under Review', key: 'Under Review' },
  { label: 'Approved', key: 'Approved' },
  { label: 'One Year Warranty', key: 'One Year Warranty' },
];

class ServiceRequestsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedGroupIds: [],
      groupData: {},
      hasMoreRecords: true,
      selectedIds: [],
      selectedServiceRequests: [],
      selectedGroupServiceRequestId: [],
      groupServiceRequestObj: [],
      showGroupServiceRequest: false,
      selectedGroupId: '',
      isGroupSelected: false,
      selectedSrsGroupId: [],
      selectedGroupServiceRequest: null,
      openServiceRequestModal: false,
      openDownloadModal: false,
      acceptGroupLabelInput: false,
      groupLabel: '',
      overlayServiceRequest: [],
      showOverlay: false,
      status: 'BULK STATUS UPDATE',
      selectAll: false,
      check: false,
      showPopup: false,
      openFiltersModal: false,
      filterValues: {
        walkthrough: [],
        startDate: '',
        endDate: '',
        project: '',
        issueType: '',
        assetType: '',
        building: '',
        level: '',
        suite: [],
        tags: [],
      },
      initialFetchServiceRequestListParams: {},
      loading: false,
    };
  }

  componentDidMount() {
    let role = this.props.user.roles[0].role.name;
    if (
      role === 'Property Developer' ||
      role === 'Strata Manager' ||
      role === 'Service Provider' ||
      role === 'Service Manager'
    ) {
      let filterEstimatedDays = headers.filter(
        (x) => x.label === 'Estimated Days'
      );
      let filterEstimatedMinutes = headers.filter(
        (x) => x.label === 'Estimated Minutes'
      );
      let filterEstimatedHours = headers.filter(
        (x) => x.label === 'Estimated Hours'
      );
      let filterActualDays = headers.filter((x) => x.label === 'Actual Days');
      let filterActualHours = headers.filter((x) => x.label === 'Actual Hours');
      let filterActualMinutes = headers.filter(
        (x) => x.label === 'Actual Minutes'
      );

      if (filterEstimatedDays.length === 0)
        headers.push({ label: 'Estimated Days', key: 'estimatedDays' });

      if (filterEstimatedHours.length === 0)
        headers.push({ label: 'Estimated Hours', key: 'estimatedHours' });

      if (filterEstimatedMinutes.length === 0)
        headers.push({ label: 'Estimated Minutes', key: 'estimatedMinutes' });

      if (filterActualDays.length === 0)
        headers.push({ label: 'Actual Days', key: 'actualDays' });

      if (filterActualHours.length === 0)
        headers.push({ label: 'Actual Hours', key: 'actualHours' });

      if (filterActualMinutes.length === 0)
        headers.push({ label: 'Actual Minutes', key: 'actualMinutes' });
    }
    this.props.clearLoadingDownloadServiceRequestList();
    this.props.clearServiceRequestByGroup();
    this.props.onfetchAllTicketStatus();
    this.props.onFetchIssueTypes();
    this.props.onExitServiceRequestForm();
    let cdays = '0 days';
    if (localStorage.getItem('cdays') === '60+ days old') {
      cdays = '60 days';
    } else if (localStorage.getItem('cdays') === '30-60 days old') {
      cdays = '30-60 days';
    } else if (localStorage.getItem('cdays') === '<30 days old') {
      cdays = '<30 days';
    }
    setTimeout(() => {
      this.setState({
        initialFetchServiceRequestListParams: {
          userID: this.props.user.id,
          role: this.props.user.roles[0].role.name,
          status: localStorage.getItem('status'),
          cdays: cdays,
          count: 1,
          text:
            localStorage.getItem('searchString') !== '' &&
            localStorage.getItem('searchString') != null
              ? localStorage.getItem('searchString')
              : this.props.searchString,
          search:
            localStorage.getItem('searchString') !== '' &&
            localStorage.getItem('searchString') != null &&
            this.props.searchString !== '' &&
            this.props.searchString != null
              ? true
              : false,
          filterValues: this.props.filterQuery,
        },
      });
      if (this.props.filterQuery.commonAreas === '') {
        this.props.clearSelectedPropertyCommonAreas();
      }
    }, 1000);
  }

  isGroupExpanded = (groupData) => {
    const isIdExpanded = this.state.expandedGroupIds.includes(groupData.id);
    return isIdExpanded;
  };

  expandGroup = (groupData) => {
    this.setState((previousState) => ({
      expandedGroupIds: [...previousState.expandedGroupIds, groupData.id],
      isGroupExpanded: true,
    }));
    if (!Object.keys(this.props.serviceRequestByGroup).includes(groupData.id)) {
      this.fetchGroupServiceRequest(groupData.id, groupData);
    }
  };

  collapseGroup = (groupData) => {
    this.deselectAllBySRsGroup(groupData);
    this.props.clearServiceRequestByGroup(groupData.id);
    const filteredGroupIds = this.state.expandedGroupIds.filter(
      (id) => id !== groupData.id
    );
    const filteredSelectedGroups = this.state.selectedSrsGroupId.filter(
      (group) => group.id !== groupData.id
    );

    this.setState((previousState) => ({
      expandedGroupIds: filteredGroupIds,
      selectedSrsGroupId: filteredSelectedGroups,
    }));
  };

  collapseAllGroups = (groupData) => {
    this.props.clearServiceRequestByGroup();
    this.setState({ expandedGroupIds: [] });
  };

  fetchMoreData = () => {
    const { pageCount, paginationCount, mainServiceRequest } = this.props;
    if (mainServiceRequest === true) {
      const { status, days } = this.props.stateData;
      if (paginationCount === pageCount) {
        this.setState({ hasMoreRecords: false });
      }
      this.props.loadServiceRequest(status, days);
    } else {
      if (paginationCount === pageCount) {
        this.setState({ hasMoreRecords: false });
      }
      this.props.loadServiceRequest();
    }
    this.setState({ selectAll: false });
  };

  onClickBulkUpdate = (id, data) => {
    let selectedServiceRequests = this.state.selectedServiceRequests;
    let selectedIds = this.state.selectedIds;
    let index = selectedIds.findIndex((object) => object.id === id);
    if (index === -1) {
      selectedIds = [...selectedIds, { id: id }];
      this.setState({ selectedIds });
      this.setState({
        selectedServiceRequests: [...this.state.selectedServiceRequests, data],
      });
    } else {
      selectedIds = selectedIds.filter((data) => data.id !== id);
      selectedServiceRequests = selectedServiceRequests.filter(
        (data) => data.id !== id
      );
      this.setState({ selectedIds, selectedServiceRequests });
    }
    this.setState({ selectAll: false });
  };

  onChangeStatus = async (e) => {
    this.setState({ status: e.target.value });
    let params = {
      serviceRequest: this.state.selectedIds,
      name: e.target.value,
      userId: this.props.user.id,
      propertyId: this.props.propertyId,
    };

    if (e.target.value === 'Declined') {
      this.setState({ showPopup: true });
    } else {
      if (e.target.value === 'Assigned') {
        this.setState({ showOverlay: true });
        this.setState({
          overlayServiceRequest: this.state.selectedServiceRequests,
          status: 'BULK STATUS UPDATE',
          selectAll: false,
        });
      } else {
        await this.props.updateBulkStatus(
          params,
          this.props.user.roles[0].role.name,
          this.state.initialFetchServiceRequestListParams,
          this.props.from
        );
        this.props.clearServiceRequestByGroup();
        this.state.selectedGroupServiceRequestId.pop();
        this.setState({
          selectedIds: [],
          overlayServiceRequest: this.state.selectedServiceRequests,
          selectedServiceRequests: [],
          status: 'BULK STATUS UPDATE',
          selectAll: false,
          isGroupSelected: false,
          selectedSrsGroupId: [],
        });
      }
    }
  };

  async handleStatus(data, id) {
    let params = {
      serviceRequest: this.state.selectedIds,
      name: 'Assigned',
      userId: this.props.user.id,
      ServiceProviderId: data.userId,
    };
    await this.props.updateBulkStatus(
      params,
      this.props.user.roles[0].role.name,
      this.state.initialFetchServiceRequestListParams,
      this.props.from
    );
    this.props.clearServiceRequestByGroup();
    this.state.selectedGroupServiceRequestId.pop();
    this.setState({
      selectedIds: [],
      showOverlay: false,
      overlayServiceRequest: this.state.selectedServiceRequests,
      selectedServiceRequests: [],
      status: 'BULK STATUS UPDATE',
      selectAll: false,
      isGroupSelected: false,
      selectedSrsGroupId: [],
    });
  }

  onSubmitPopup = async (type, data) => {
    if (type === 'cancel') {
      this.setState({
        showPopup: false,
        selectedIds: [],
        status: 'BULK STATUS UPDATE',
        selectAll: false,
        isGroupSelected: false,
        selectedSrsGroupId: [],
      });
    } else {
      let params = {
        serviceRequest: this.state.selectedIds,
        name: 'Declined',
        userId: this.props.user.id,
        Reason: data.description,
        ReasonType: data.reason,
      };
      this.setState({ showPopup: false });

      await this.props.updateBulkStatus(
        params,
        this.props.user.roles[0].role.name,
        this.state.initialFetchServiceRequestListParams,
        this.props.from
      );
      this.props.clearServiceRequestByGroup();
      this.state.selectedGroupServiceRequestId.pop();
      this.setState({
        selectedIds: [],
        status: 'BULK STATUS UPDATE',
        selectAll: false,
        isGroupSelected: false,
        selectedSrsGroupId: [],
      });
    }
  };

  selectAll = () => {
    let selectedIds = [];
    let selectedGroups = [];
    let { serviceRequests } = this.props;
    if (this.state.selectAll === false) {
      serviceRequests.forEach((s) => {
        if (s.requestType === 'Grouping') {
          if (
            this.state.selectedSrsGroupId.findIndex((id) => s.id === id.id) ===
            -1
          ) {
            if (!this.isGroupExpanded(s)) {
              this.expandGroup(s);
            }
            selectedGroups.push(s);
          }
        } else {
          selectedIds = [...selectedIds, { id: s.id }];
        }
      });
      this.setState({
        selectedIds: selectedIds,
        selectedServiceRequests: serviceRequests,
        selectedSrsGroupId: selectedGroups,
        loading: false,
      });
      setTimeout(
        () =>
          selectedGroups.forEach((group) => this.selectAllBySRsGroup(group)),
        500
      );
    } else {
      this.setState({
        selectedIds: [],
        selectedServiceRequests: [],
        expandedGroupIds: [],
        selectedSrsGroupId: [],
      });
      this.collapseAllGroups();
    }
    this.setState({ selectAll: !this.state.selectAll });
  };

  selectAllBySRsGroup = (data) => {
    this.setState({ loading: true });
    let selectedIds = [];
    let { serviceRequestByGroup: groupedServiceRequests } = this.props;
    const serviceRequestByGroup = groupedServiceRequests[data.id];
    if (serviceRequestByGroup?.length > 0) {
      selectedIds = serviceRequestByGroup.map((s) => ({ id: s.id }));
      this.setState({
        selectedIds: [...this.state.selectedIds, ...selectedIds],
        selectedServiceRequests: serviceRequestByGroup,
      });
    }
    this.setState({ loading: false });
  };

  deselectAllBySRsGroup = (data) => {
    this.setState({ loading: true });
    let selectedIds = [...this.state.selectedIds];
    let { serviceRequestByGroup: groupedServiceRequests } = this.props;
    const serviceRequestByGroup = groupedServiceRequests[data.id];
    if (serviceRequestByGroup?.length > 0) {
      this.setState({
        selectedIds: selectedIds.filter(
          (selected) =>
            serviceRequestByGroup.findIndex((sr) => selected.id === sr.id) ===
            -1
        ),
        loading: false,
      });
    }
    this.setState({ loading: false });
  };

  download() {
    const { download, fetchSelectedServiceRequestCSVExportDownloadList } =
      this.props;
    if (this.state.selectedIds.length > 0) {
      const selectedIdsArray = this.state.selectedIds.map((item) => item.id);
      fetchSelectedServiceRequestCSVExportDownloadList(selectedIdsArray);
    } else {
      download();
    }
    this.setState({
      check: true,
      openDownloadModal: false,
    });
  }

  downloadPDF() {
    const {
      user,
      downloadPDF,
      fetchSelectedServiceRequestPDFExportDownloadList,
    } = this.props;
    if (this.state.selectedIds.length > 0) {
      const selectedIdsArray = this.state.selectedIds.map((item) => item.id);
      const selectedIdsStrings = selectedIdsArray.toString();
      const selectedIdsParams = selectedIdsStrings.replaceAll(',', '&');
      fetchSelectedServiceRequestPDFExportDownloadList(
        user.id,
        selectedIdsParams
      );
    } else {
      downloadPDF();
    }
    this.setState({
      openDownloadModal: false,
    });
  }

  getBuildings(propertyId) {
    const { getPropertyBuildings } = this.props;
    getPropertyBuildings(propertyId);
  }

  getBuildingsLevels(buildingId) {
    const { getBuildingLevels } = this.props;
    getBuildingLevels(buildingId);
  }

  getPropertySuites(propertyId) {
    const { onFetchPropertySuites, user } = this.props;
    onFetchPropertySuites(propertyId, user.id, user.roles[0].role.name);
  }

  getPropertyCommonAreas(propertyId) {
    const { fetchPropertyCommonAreas } = this.props;
    fetchPropertyCommonAreas(propertyId);
  }

  setFilterData(value) {
    const { filterBySearch, addFilterQuery } = this.props;
    this.setState({ filterValues: value });
    const localFilterValue = this.state.initialFetchServiceRequestListParams;
    localFilterValue.filterValues = value;
    this.setState({ initialFetchServiceRequestListParams: localFilterValue });
    filterBySearch(value);
    addFilterQuery(value);
    let pathName = window.location.pathname;
    if (pathName.indexOf('/app/service-requests') === 0) {
      localStorage.setItem(
        'searchByFilterValues',
        value ? JSON.stringify(value) : this.props.filterQuery
      );
    }
  }

  filteredByTag(value, onClose) {
    return (
      <div
        style={{
          margin: '10px 5px',
          padding: '2px',
          color: 'black',
          fontFamily: 'sans-serif',
          fontSize: '1.3rem',
        }}
      >
        {value}
        <span onClick={onClose}>
          <svg
            width="15"
            height="15"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.96 12.75L19.5 18.29V19.75H18.04L12.5 14.21L6.96 19.75H5.5V18.29L11.04 12.75L5.5 7.21V5.75H6.96L12.5 11.29L18.04 5.75H19.5V7.21L13.96 12.75Z"
              fill="black"
            />
          </svg>
        </span>
      </div>
    );
  }

  fiteredBy() {
    const {
      properties,
      items,
      buildingsList,
      levelsList,
      filterServiceProviderandPropertyDeveloperList,
      selectedPropertyCommonAreas,
    } = this.props;
    const commonAreasData = selectedPropertyCommonAreas || [];
    let projectName = properties.find(
      (item) => item.propertyId === this.props.filterQuery.project
    );
    let commonAreas = commonAreasData.filter(
      (item) => item.id === this.props.filterQuery.commonAreas
    )[0];

    let assetName = items.find(
      (item) => item.typeId === this.props.filterQuery.assetType
    );

    let buildingName = buildingsList.find(
      (item) => item.id === this.props.filterQuery.building
    );
    let levelName = levelsList.find(
      (item) => item.id === this.props.filterQuery.level
    );

    let assignTo = filterServiceProviderandPropertyDeveloperList.find(
      (item) => item.id === this.props.filterQuery.assignTo
    );
    return (
      <>
        {this.props.filterQuery.walkthrough
          ? this.props.filterQuery.walkthrough.map((item) =>
              this.filteredByTag(item, () => {
                let value = {
                  ...this.props.filterQuery,
                  walkthrough: this.props.filterQuery.walkthrough.filter(
                    (type) => {
                      return type !== item;
                    }
                  ),
                };
                this.setFilterData(value);
              })
            )
          : null}
        {this.props.filterQuery.startDate
          ? this.filteredByTag(
              this.props.filterQuery.startDate +
                ' to ' +
                this.props.filterQuery.endDate,
              () => {
                let value = {
                  ...this.props.filterQuery,
                  startDate: '',
                  endDate: '',
                };
                this.setFilterData(value);
              }
            )
          : null}
        {this.props.filterQuery.project
          ? this.filteredByTag(projectName.name, () => {
              let value = {
                ...this.props.filterQuery,
                project: '',
                suite: [],
                building: '',
                level: '',
                commonAreas: '',
              };
              this.setFilterData(value);
            })
          : null}

        {this.props.filterQuery.commonAreas
          ? this.filteredByTag(
              commonAreas === undefined ? '' : commonAreas.name,
              () => {
                let value = { ...this.props.filterQuery, commonAreas: '' };
                this.setFilterData(value);
              }
            )
          : null}

        {this.props.filterQuery.suite
          ? this.props.filterQuery.suite.map((item) =>
              this.filteredByTag(item.name, () => {
                let value = {
                  ...this.props.filterQuery,
                  suite: this.props.filterQuery.suite.filter((type) => {
                    return type.name !== item.name;
                  }),
                };
                this.setFilterData(value);
              })
            )
          : null}

        {this.props.filterQuery.tags
          ? this.props.filterQuery.tags.map((item) =>
              this.filteredByTag(item.label, () => {
                let value = {
                  ...this.props.filterQuery,
                  tags: this.props.filterQuery.tags.filter((type) => {
                    return type.value !== item.value;
                  }),
                };
                this.setFilterData(value);
              })
            )
          : null}

        {this.props.filterQuery.issueType
          ? this.filteredByTag(this.props.filterQuery.issueType, () => {
              let value = { ...this.props.filterQuery, issueType: '' };
              this.setFilterData(value);
            })
          : null}
        {this.props.filterQuery.assetType
          ? this.filteredByTag(assetName.typeName, () => {
              let value = { ...this.props.filterQuery, assetType: '' };
              this.setFilterData(value);
            })
          : null}
        {this.props.filterQuery.building
          ? this.filteredByTag(buildingName.building, () => {
              let value = {
                ...this.props.filterQuery,
                building: '',
                level: '',
              };
              this.setFilterData(value);
            })
          : null}
        {this.props.filterQuery.level
          ? this.filteredByTag(levelName.level, () => {
              let value = { ...this.props.filterQuery, level: '' };
              this.setFilterData(value);
            })
          : null}

        {this.props.filterQuery.assignTo
          ? this.filteredByTag(
              `${assignTo.firstname} ${assignTo.lastname}`,
              () => {
                let value = { ...this.props.filterQuery, assignTo: '' };
                this.setFilterData(value);
              }
            )
          : null}
      </>
    );
  }

  handleGroupByCall = () => {
    const { serviceRequests } = this.props;
    let propertyId = this.state.selectedServiceRequests[0].propertyId;
    let properties = this.state.selectedServiceRequests.filter(
      (data) => data.propertyId !== propertyId
    );
    let groupServiceRequestExist = serviceRequests.filter(
      (data) => data.requestType === 'Grouping'
    );
    this.setState({ groupServiceRequestObj: groupServiceRequestExist });

    if (properties.length > 0) {
      toast.success(
        ` ⓘ You can only group ${variables.serviceRequest.toLowerCase()}s from the same property.`,
        { autoClose: 6000, position: 'top-center' }
      );
    } else if (groupServiceRequestExist.length > 0) {
      this.setState({ openServiceRequestModal: true });
    } else {
      this.setState({
        openServiceRequestModal: true,
        acceptGroupLabelInput: true,
      });
    }
  };

  createNewGroup = () => {
    this.setState({ openServiceRequestModal: false });

    let cdays = '0 days';
    if (localStorage.getItem('cdays') === '60+ days old') {
      cdays = '60 days';
    } else if (localStorage.getItem('cdays') === '30-60 days old') {
      cdays = '30-60 days';
    } else if (localStorage.getItem('cdays') === '<30 days old') {
      cdays = '<30 days';
    }
    this.setState({
      initialFetchServiceRequestListParams: {
        userID: this.props.user.id,
        role: this.props.user.roles[0].role.name,
        status: localStorage.getItem('status'),
        cdays: cdays,
        count: 1,
        text: this.props.searchString,
        search:
          this.props.searchString !== '' && this.props.searchString != null
            ? true
            : false,
        filterValues: this.props.filterQuery,
      },
    });
    const { user, createServiceRequestByGroup } = this.props;

    let srIds = this.state.selectedServiceRequests.map((data) => {
      let params = {
        id: data.id,
      };
      return params;
    });

    let text = `Are you sure you want to create a group for the selected ${variables.serviceRequest}?`;
    if (window.confirm(text) === true) {
      const serviceRequestsGroupingParams = {
        GroupName: this.state.groupLabel,
        id: null,
        PropertyId: this.state.selectedServiceRequests[0].propertyId,
        UserId: user.id,
        Subject: null,
        Description: null,
        SuiteId: null,
        AssetId: null,
        IssueTypeId: null,
        IssueTypeName: null,
        ServiceRequest: srIds,
      };
      createServiceRequestByGroup(
        serviceRequestsGroupingParams,
        this.state.initialFetchServiceRequestListParams
      );
    }
  };

  addServiceRequestToGroup = (groupId) => {
    let cdays = '0 days';
    if (localStorage.getItem('cdays') === '60+ days old') {
      cdays = '60 days';
    } else if (localStorage.getItem('cdays') === '30-60 days old') {
      cdays = '30-60 days';
    } else if (localStorage.getItem('cdays') === '<30 days old') {
      cdays = '<30 days';
    }
    this.setState({
      initialFetchServiceRequestListParams: {
        userID: this.props.user.id,
        role: this.props.user.roles[0].role.name,
        status: localStorage.getItem('status'),
        cdays: cdays,
        count: 1,
        text: this.props.searchString,
        search:
          this.props.searchString !== '' && this.props.searchString != null
            ? true
            : false,
        filterValues: this.props.filterQuery,
      },
    });

    let notSameProperty = this.state.selectedServiceRequests.filter(
      (item) =>
        item.propertyId !== this.state.selectedGroupServiceRequest.propertyId
    );
    if (notSameProperty.length > 0) {
      this.setState({
        selectedServiceRequests: [],
        selectedIds: [],
        selectedGroupServiceRequest: null,
        selectedGroupId: [],
        showGroupServiceRequest: false,
        openServiceRequestModal: false,
      });
      toast.success(
        ` ⓘ You can only group ${variables.serviceRequest.toLowerCase()}s from the same property.`,
        { autoClose: 6000, position: 'top-center' }
      );
    } else {
      const { user, createServiceRequestByGroup } = this.props;
      this.setState({ openServiceRequestModal: false });

      let srIds = this.state.selectedServiceRequests.map((data) => {
        let params = {
          id: data.id,
        };
        return params;
      });

      let text = `Are you sure you want to add the selected ${variables.serviceRequest.toLowerCase()} into a existing group?`;
      if (window.confirm(text) === true) {
        const serviceRequestsGroupingParams = {
          GroupName: null,
          id: groupId,
          PropertyId: this.state.selectedServiceRequests[0].propertyId,
          UserId: user.id,
          Subject: null,
          Description: null,
          SuiteId: null,
          AssetId: null,
          IssueTypeId: null,
          IssueTypeName: null,
          ServiceRequest: srIds,
        };
        createServiceRequestByGroup(
          serviceRequestsGroupingParams,
          this.state.initialFetchServiceRequestListParams
        );
      }
    }
  };

  fetchGroupServiceRequest = (id) => {
    // Modified by: Tarkeshwar Prasad Yadav
    // Modified on: 06/09/2022
    // Jira ticket: JUN-3186
    // Comment: Now SRs of group can be fetched.

    let cdays = '0 days';
    if (localStorage.getItem('cdays') === '60+ days old') {
      cdays = '60 days';
    } else if (localStorage.getItem('cdays') === '30-60 days old') {
      cdays = '30-60 days';
    } else if (localStorage.getItem('cdays') === '<30 days old') {
      cdays = '<30 days';
    }
    this.setState({
      initialFetchServiceRequestListParams: {
        userID: this.props.user.id,
        role: this.props.user.roles[0].role.name,
        status: localStorage.getItem('status'),
        cdays: cdays,
        count: 1,
        text: this.props.searchString,
        search:
          this.props.searchString !== '' && this.props.searchString != null
            ? true
            : false,
        filterValues: this.props.filterQuery,
      },
    });
    const {
      fetchGroupServiceRequest: fetchGSR,
      serviceRequests,
      setCurrentGroupServiceRequestIndex,
    } = this.props;
    const index = serviceRequests.findIndex((x) => x.id === id);
    setCurrentGroupServiceRequestIndex(index);
    fetchGSR(
      id,
      this.state.initialFetchServiceRequestListParams.userID,
      this.state.initialFetchServiceRequestListParams.role,
      this.state.initialFetchServiceRequestListParams.status,
      cdays,
      this.state.initialFetchServiceRequestListParams.count,
      this.props.searchString,
      this.state.initialFetchServiceRequestListParams.search,
      this.state.initialFetchServiceRequestListParams.filterValues
    );
  };

  handleDeleteServiceRequestGroup = (data) => {
    // Modified by: Tarkeshwar Prasad Yadav
    // Modified on: 06/09/2022
    // Jira ticket: JUN-3186
    // Comment: Now SRs of group can be fetched.

    let cdays = '0 days';
    if (localStorage.getItem('cdays') === '60+ days old') {
      cdays = '60 days';
    } else if (localStorage.getItem('cdays') === '30-60 days old') {
      cdays = '30-60 days';
    } else if (localStorage.getItem('cdays') === '<30 days old') {
      cdays = '<30 days';
    }
    this.setState({
      initialFetchServiceRequestListParams: {
        userID: this.props.user.id,
        role: this.props.user.roles[0].role.name,
        status: localStorage.getItem('status'),
        cdays: cdays,
        count: 1,
        text: this.props.searchString,
        search:
          this.props.searchString !== '' && this.props.searchString != null
            ? true
            : false,
        filterValues: this.props.filterQuery,
      },
    });
    // Modified by: Tarkeshwar Prasad Yadav
    // Modified on: 29/08/2022
    // Jira ticket: JUN-3165
    let text = `Are you sure you want to delete the selected group of ${variables.serviceRequest}?`;
    if (window.confirm(text) === true) {
      const { deleteServiceRequestGroup, user } = this.props;
      deleteServiceRequestGroup(
        data.id,
        user.id,
        this.state.initialFetchServiceRequestListParams
      );
    }
  };

  handleDeleteServiceRequestFromGroup = (data) => {
    let cdays = '0 days';
    if (localStorage.getItem('cdays') === '60+ days old') {
      cdays = '60 days';
    } else if (localStorage.getItem('cdays') === '30-60 days old') {
      cdays = '30-60 days';
    } else if (localStorage.getItem('cdays') === '<30 days old') {
      cdays = '<30 days';
    }
    this.setState({
      initialFetchServiceRequestListParams: {
        userID: this.props.user.id,
        role: this.props.user.roles[0].role.name,
        status: localStorage.getItem('status'),
        cdays: cdays,
        count: 1,
        text: this.props.searchString,
        search:
          this.props.searchString !== '' && this.props.searchString != null
            ? true
            : false,
        filterValues: this.props.filterQuery,
      },
    });
    let text = `Are you sure you want to remove the selected ${variables.serviceRequest} from the current group?`;
    if (window.confirm(text) === true) {
      const { deleteServiceRequestFromGroup, user } = this.props;
      deleteServiceRequestFromGroup(
        data.id,
        user.id,
        this.state.initialFetchServiceRequestListParams
      );
    }
  };

  render() {
    const {
      serviceRequests,
      from,
      onSearch,
      serviceRequest,
      pageCount,
      paginationCount,
      serviceRequestFormIsVisible,
      onSetServiceRequestFormIsVisible,
      search,
      itemView,
      strapline,
      user,
      mainServiceRequest,
      csvExportLoading,
      csvExportDownloadedServiceRequestList,
      csvLoadingDone,
      properties,
      issueTypes,
      items,
      buildingsList,
      levelsList,
      searchString,
      propertySuites,
      introContent,
      fetchedPropertyCommonAreas,
    } = this.props;

    let pathName = window.location.pathname;
    let sortableServiceRequest = serviceRequests.map((sr) => ({
      ...sr,
      sortableUnitName: suiteName(sr, from),
      sortableCommonAreaName: commonAreaName(sr, from),
      sortableIssueType: sortableType(sr),
    }));

    return (
      <>
        {introContent && (
          <ContentBlock content={IntroContent.serviceRequests} />
        )}
        <Actions compact>
          <div className="searchbar serviceRequestsSearch">
            <Search
              size="small"
              placeholder={`Search ${variables.serviceRequest}s...`}
              value={searchString}
              onChange={onSearch}
            />
            <div className="serviceRequestsTable searchbar1">
              {pathName === '/app/service-requests' ? (
                <>
                  <Button
                    color="teal"
                    label="Filter By"
                    size="small"
                    onClick={() => this.setState({ openFiltersModal: true })}
                    icon={<Icon glyph="filter" weight="light" size="small" />}
                  />
                  <Modal
                    open={this.state.openFiltersModal}
                    onClose={() => this.setState({ openFiltersModal: false })}
                    modal={true}
                    closeOnDocumentClick={false}
                    className="popup-content"
                  >
                    <FilterModal
                      onClose={() => this.setState({ openFiltersModal: false })}
                      filterValues={this.props.filterQuery}
                      setFilterData={(value) => this.setFilterData(value)}
                      properties={properties}
                      fetchedPropertyCommonAreas={fetchedPropertyCommonAreas}
                      issueTypes={issueTypes}
                      assetTypes={items}
                      getPropertySuites={(propertyId) => {
                        this.getPropertySuites(propertyId);
                        this.getPropertyCommonAreas(propertyId);
                      }}
                      propertySuites={propertySuites}
                      getBuildings={(propertyId) =>
                        this.getBuildings(propertyId)
                      }
                      buildingsList={buildingsList}
                      getBuildingsLevels={(buildingId) =>
                        this.getBuildingsLevels(buildingId)
                      }
                      levelsList={levelsList}
                    />
                  </Modal>
                </>
              ) : null}
              {serviceRequests &&
              serviceRequests.length > 0 &&
              user.roles[0].role.name !== 'Home Owner' &&
              user.roles[0].role.name !== 'Vendor' ? (
                <div></div>
              ) : null}

              <div
                className="CreateRequestButtonM"
                style={{ display: 'inline-block', float: 'right' }}
              >
                {(itemView && itemView === true) ||
                user.roles[0].role.name === 'Vendor' ||
                user.roles[0].role.name === 'Service Provider' ||
                user.roles[0].role.name === 'Realtor' ||
                mainServiceRequest ? null : (
                  <Button
                    color="teal"
                    label="Create Request"
                    onClick={() => onSetServiceRequestFormIsVisible(true)}
                    icon={<Icon glyph="wrench" weight="light" size="small" />}
                    size="small"
                  />
                )}
              </div>
              <div className="serviceRequestsDown">
                {serviceRequests && serviceRequests.length > 0 && (
                  <div
                    onClick={() => this.setState({ openDownloadModal: true })}
                    style={{ cursor: 'pointer' }}
                  >
                    <Icon glyph="download" weight="regular" size="big" />
                  </div>
                )}
                {csvLoadingDone === true ? (
                  <CSVDownload
                    data={csvExportDownloadedServiceRequestList}
                    headers={headers}
                    filename="ServiceRequests.csv"
                    target="_blank"
                  />
                ) : null}
              </div>

              {user.roles[0].role.name === 'Home Owner' ||
              user.roles[0].role.name === 'Realtor' ||
              user.roles[0].role.name === 'Vendor' ? null : (
                <>
                  <div className="bulkUpdateServReq">
                    <select
                      className={classNames('select__bulkUpdate_options', {
                        'select__bulkUpdate_options--background':
                          this.state.selectedIds.length > 0 ||
                          this.state.isGroupSelected
                            ? true
                            : false,
                      })}
                      disabled={
                        this.state.selectedIds.length > 0 ||
                        this.state.isGroupSelected
                          ? false
                          : true
                      }
                      onChange={(e) => this.onChangeStatus(e)}
                      value={this.state.status ? this.state.status : ''}
                    >
                      <option disabled="disabled">BULK STATUS UPDATE</option>
                      {statuses.map((stat, i) => (
                        <option key={i} value={stat.label}>
                          {stat.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="groupByBtn">
                    {pathName === '/app/service-requests' ? (
                      <Button
                        color="teal"
                        label="Group"
                        size="small"
                        disabled={
                          this.state.selectedIds.length > 0 ? false : true
                        }
                        onClick={() => this.handleGroupByCall()}
                      />
                    ) : null}
                  </div>
                  <div className="servReqSelectAll">
                    <Checkbox
                      label="Select All"
                      value={this.state.selectAll}
                      onChange={() => this.selectAll()}
                    />
                  </div>
                </>
              )}
              {this.props.from === 'dashboard' && (
                <div className="servReqSelectAll">
                  <Checkbox
                    label="Show Resolved Tickets"
                    value={this.props.displayClosedAndResolvedTickets}
                    onChange={() => {
                      this.props.setDisplayClosedAndResolvedTickets(
                        !this.props.displayClosedAndResolvedTickets
                      );
                      this.props.filterBySearch(this.props.filterQuery);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </Actions>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
          }}
        >
          {this.props.from !== 'dashboard' ? null : this.fiteredBy()}
        </div>

        {csvExportLoading === true ? <Loader center={true} /> : null}

        {serviceRequests && serviceRequests.length > 0 ? (
          <>
            {this.props.formLoader || this.state.loading === true ? (
              <div
                style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Loader loading={true} center={true} />
              </div>
            ) : null}
            <div
              id="scrollableDiv"
              className="serviceRequestsTable__container"
              style={{}}
            >
              <InfiniteScroll
                dataLength={serviceRequests.length}
                style={{ display: 'flex', flexDirection: 'column' }}
                inverse={false}
                hasMore={this.state.hasMoreRecords}
                loader={
                  paginationCount === pageCount ||
                  serviceRequests.length === 1 ? (
                    <div />
                  ) : (
                    <h4>Loading...</h4>
                  )
                }
                scrollableTarget="scrollableDiv"
                next={this.fetchMoreData}
              >
                <GroupingTable
                  indexID={this.props.serviceRequestByGroupIndex}
                  selectedIds={this.state.selectedIds}
                  selectedServiceRequests={this.state.selectedServiceRequests}
                  expandedGroups={this.state.expandedGroupIds}
                  from={from}
                  applyMinWidth={true}
                  fetchGroupServiceRequest={(id, data) =>
                    this.fetchGroupServiceRequest(id, data)
                  }
                  onClickBulkUpdate={(id, data) =>
                    this.onClickBulkUpdate(id, data)
                  }
                  handleDeleteServiceRequestFromGroup={(data) =>
                    this.handleDeleteServiceRequestFromGroup(data)
                  }
                  columns={[
                    {
                      label: '',
                      cell: (data) => {
                        let selectedObj =
                          this.state.selectedIds.length > 0
                            ? this.state.selectedIds.find(
                                (object) => object.id === data.id
                              )
                            : null;
                        let selectedId =
                          selectedObj === undefined || selectedObj === null
                            ? null
                            : selectedObj && selectedObj.id
                              ? selectedObj.id
                              : null;
                        return (
                          <div
                            style={{ flexDirection: 'row', display: 'flex' }}
                          >
                            {user.roles[0].role.name === 'Home Owner' ||
                            user.roles[0].role.name ===
                              'Vendor' ? null : data.requestType ===
                              'Grouping' ? (
                              <>
                                <Checkbox
                                  checked={
                                    this.state.selectedSrsGroupId.findIndex(
                                      (group) => group.id === data.id
                                    ) !== -1
                                  }
                                  name={
                                    this.state.selectedSrsGroupId.findIndex(
                                      (group) => group.id === data.id
                                    ) !== -1
                                      ? data.id
                                      : null
                                  }
                                  value={
                                    this.state.selectedSrsGroupId.findIndex(
                                      (group) => group.id === data.id
                                    ) !== -1
                                      ? data.id
                                      : ''
                                  }
                                  onClick={() => {
                                    if (
                                      this.state.selectedSrsGroupId.findIndex(
                                        (id) => data.id === id.id
                                      ) === -1
                                    ) {
                                      this.setState({
                                        isGroupSelected: true,
                                        selectedSrsGroupId: [
                                          ...this.state.selectedSrsGroupId,
                                          data,
                                        ],
                                        loading: true,
                                      });
                                      if (!this.isGroupExpanded(data)) {
                                        this.expandGroup(data);
                                        setTimeout(
                                          () => this.selectAllBySRsGroup(data),
                                          500
                                        );
                                      } else {
                                        this.selectAllBySRsGroup(data);
                                      }
                                    } else {
                                      this.setState({
                                        selectedSrsGroupId:
                                          this.state.selectedSrsGroupId.filter(
                                            (id) => id.id !== data.id
                                          ),
                                      });
                                      this.deselectAllBySRsGroup(data);
                                    }
                                    this.setState({ selectAll: false });
                                  }}
                                  readOnly
                                />
                                {this.isGroupExpanded(data) ? (
                                  <>
                                    <div
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => {
                                        this.collapseGroup(data);
                                      }}
                                    >
                                      <Icon
                                        glyph="angle-up"
                                        weight="regular"
                                        size="big"
                                      />{' '}
                                      &nbsp;&nbsp;
                                    </div>
                                    <span
                                      style={{ cursor: 'pointer' }}
                                      onClick={() =>
                                        this.handleDeleteServiceRequestGroup(
                                          data
                                        )
                                      }
                                    >
                                      {' '}
                                      <Icon
                                        glyph="object-ungroup"
                                        weight="regular"
                                        size="big"
                                      />{' '}
                                      &nbsp;&nbsp;
                                    </span>
                                  </>
                                ) : (
                                  <div
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      this.expandGroup(data);
                                      this.fetchGroupServiceRequest(
                                        data.id,
                                        data
                                      );
                                      this.state.selectedGroupServiceRequestId.push(
                                        { id: data.id }
                                      );
                                    }}
                                  >
                                    <Icon
                                      glyph="angle-down"
                                      weight="regular"
                                      size="big"
                                    />{' '}
                                    &nbsp;&nbsp;
                                  </div>
                                )}
                              </>
                            ) : (
                              //non-grouped item checkbox
                              <Checkbox
                                checked={selectedId === data.id}
                                name={selectedId ? selectedId : null}
                                value={selectedId ? selectedId : ''}
                                onClick={() =>
                                  this.onClickBulkUpdate(data.id, data)
                                }
                                readOnly
                              />
                            )}
                            {data.requestType === 'Grouping' ? (
                              <></>
                            ) : (
                              <Link
                                to={{
                                  pathname: PATHS.SERVICE_REQUESTS_VIEW.replace(
                                    ':id',
                                    data.id
                                  ),
                                  state: { navigateTo: this.props.navigateTo },
                                }}
                              ></Link>
                            )}
                          </div>
                        );
                      },
                      style: { width: '7rem' },
                      minWidth: '7rem',
                    },
                    {
                      label:
                        from === 'CommonArea'
                          ? 'CommonArea #'
                          : `${variables.Suite} | SL #`,
                      sortable: true,
                      cell: (data) =>
                        data.requestType === 'Grouping' ? (
                          from === 'CommonArea' ? (
                            data.commonAreaName
                          ) : data.suiteName ? (
                            <div
                              title={
                                data.suiteName +
                                (data.stratalot ? ' | ' + data.stratalot : '')
                              }
                              className="cut-text"
                            >
                              {data.suiteName +
                                (data.stratalot ? ' | ' + data.stratalot : '')}
                            </div>
                          ) : (
                            <div
                              title={
                                data.requestType === 'Grouping'
                                  ? data.ticketNumber
                                  : 'Common Area'
                              }
                              className="cut-text"
                            >
                              {data.requestType === 'Grouping'
                                ? data.ticketNumber
                                : 'Common Area'}
                            </div>
                          )
                        ) : (
                          <Link
                            to={{
                              pathname: PATHS.SERVICE_REQUESTS_VIEW.replace(
                                ':id',
                                data.id
                              ),
                              state: { navigateTo: this.props.navigateTo },
                            }}
                          >
                            {from === 'CommonArea' ? (
                              <div title={data.commonAreaName}>
                                {data.commonAreaName}
                              </div>
                            ) : data.suiteName ? (
                              <div
                                title={
                                  data.suiteName +
                                  (data.stratalot ? ' | ' + data.stratalot : '')
                                }
                                className="cut-text"
                              >
                                {data.suiteName +
                                  (data.stratalot
                                    ? ' | ' + data.stratalot
                                    : '')}
                              </div>
                            ) : data.requestType === 'Grouping' ? (
                              <div title={data.ticketNumber}>
                                {data.ticketNumber}
                              </div>
                            ) : (
                              <div title={'Common Area'}>Common Area</div>
                            )}
                          </Link>
                        ),
                      accessor: 'sortableUnitName',
                      style: { width: '13rem' },
                      minWidth: '13rem',
                    },
                    {
                      xsHide: true,
                      label: 'Description',
                      sortable: true,
                      accessor: 'description',
                      cell: (data) => (
                        <div title={data.description}>{data.description}</div>
                      ),
                      minWidth: '35rem',
                    },
                    {
                      xsHide: true,
                      label: 'Room/Area',
                      sortable: true,
                      accessor: 'sortableCommonAreaName',
                      cell: (data) =>
                        data.commonAreaName
                          ? data.commonAreaName
                          : data.area && data.area.name
                            ? data.area.name
                            : '',
                      style: { width: '13rem' },
                      minWidth: '13rem',
                    },
                    {
                      xsHide: true,
                      label: 'Asset',
                      sortable: true,
                      accessor: 'itemName',
                      cell: (data) => data.itemName,
                      style: { width: '10rem' },
                      minWidth: '10rem',
                    },
                    {
                      xsHide: true,
                      label: 'Type',
                      sortable: true,
                      accessor: 'sortableIssueType',
                      cell: (data) => (
                        <div
                          title={
                            data.requestType !== 'Grouping'
                              ? data.requestType === 'CommonArea'
                                ? 'Common'
                                : data.requestType === null
                                  ? 'Warranty'
                                  : data.requestType
                              : ''
                          }
                          className="cut-text"
                        >
                          {data.requestType !== 'Grouping'
                            ? data.requestType === 'CommonArea'
                              ? 'Common'
                              : data.requestType
                            : ''}
                        </div>
                      ),
                      style: { width: '8rem' },
                      minWidth: '8rem',
                    },
                    {
                      label: 'Status',
                      showOverflow: true,
                      sortable: true,
                      accessor: 'status',
                      cell: (data) => (
                        <>
                          <Status
                            icon={
                              data.status === 'Under Review' ? (
                                <Icon
                                  glyph="hourglass-end"
                                  weight="light"
                                  size="solid"
                                />
                              ) : data.status === 'One Year Warranty' ? (
                                <Icon
                                  glyph="certificate"
                                  weight="solid"
                                  size="solid"
                                />
                              ) : (
                                <IcoMoon glyph={ICONS[data.status]} />
                              )
                            }
                            label={<div title={data.status}>{data.status}</div>}
                          />
                        </>
                      ),
                      style: { width: '10rem' },
                      minWidth: '10rem',
                    },
                    {
                      label: 'Submitted On',
                      sortable: true,
                      accessor: 'createdDate',
                      sortingAlgorithm: sortByDate,
                      cell: (data) => {
                        const days = moment().diff(
                          moment(data.createdDate),
                          'days'
                        );
                        const color =
                          days <= 30 ? 'teal' : days <= 60 ? 'yellow' : 'red';
                        return (
                          <Label
                            color={color}
                            label={serviceRequestTableLocalTime(
                              data.createdDate
                            )}
                          />
                        );
                      },
                      style: { width: '10rem' },
                      minWidth: '10rem',
                    },

                    (user.roles[0].role.name?.toUpperCase() ===
                      USER_ROLES.PROPERTY_DEVELOPER.toUpperCase() ||
                      user.roles[0].role.name?.toUpperCase() ===
                        USER_ROLES.STRATA_MANAGER.toUpperCase() ||
                      user.roles[0].role.name?.toUpperCase() ===
                        USER_ROLES.SERVICE_PROVIDER.toUpperCase() ||
                      user.roles[0].role.name?.toUpperCase() ===
                        USER_ROLES.SERVICE_MANAGER.toUpperCase()) && {
                      xsHide: true,
                      sortable: true,
                      accessor:
                        localStorage.getItem('theme') === 'Essence'
                          ? 'warrantyStartDate'
                          : 'serviceProvider',
                      sortingAlgorithm:
                        localStorage.getItem('theme') === 'Essence'
                          ? sortByDate
                          : undefined,
                      label:
                        localStorage.getItem('theme') === 'Essence'
                          ? 'Warranty Start Date'
                          : 'Assigned To',
                      cell: (data) =>
                        localStorage.getItem('theme') === 'Essence' ? (
                          <div
                            title={serviceRequestTableLocalTime(
                              data.warrantyStartDate
                            )}
                            className="cut-text"
                          >
                            {serviceRequestTableLocalTime(
                              data.warrantyStartDate
                            )}
                          </div>
                        ) : (
                          <div
                            title={data.serviceProvider}
                            className="cut-text"
                          >
                            {data.serviceProvider}
                          </div>
                        ),
                      style: { width: '13rem' },
                      minWidth: '13rem',
                    },
                    (user.roles[0].role.name?.toUpperCase() ===
                      USER_ROLES.PROPERTY_DEVELOPER.toUpperCase() ||
                      user.roles[0].role.name?.toUpperCase() ===
                        USER_ROLES.STRATA_MANAGER.toUpperCase() ||
                      user.roles[0].role.name?.toUpperCase() ===
                        USER_ROLES.SERVICE_PROVIDER.toUpperCase() ||
                      user.roles[0].role.name?.toUpperCase() ===
                        USER_ROLES.SERVICE_MANAGER.toUpperCase()) && {
                      xsHide: true,
                      sortable: true,
                      accessor: 'scheduleDatest',
                      sortingAlgorithm: sortByDate,
                      label: 'Scheduled Date/Time',
                      cell: (data) => (
                        <div
                          title={
                            data.scheduleDatest ? data.scheduleDatest : null
                          }
                        >
                          {data.scheduleDatest ? data.scheduleDatest : null}
                        </div>
                      ),
                      style: { width: '10rem' },
                      minWidth: '10rem',
                    },
                  ]}
                  data={sortableServiceRequest}
                />
              </InfiniteScroll>
            </div>
          </>
        ) : (
          <Empty
            direction="ttb"
            headline={`Your ${variables.serviceRequest.toLowerCase()} inbox is empty`}
            strapline={
              strapline && strapline.length > 0
                ? strapline
                : `All ${variables.serviceRequest.toLowerCase()}s` +
                  (user.roles[0].role.name === 'Admin' ? ' ' : ' you ') +
                  'add will be listed here so it’s easier for you to manage.'
            }
            searchIsActive={
              search && search.serviceRequests ? search.serviceRequests : ''
            }
            cta={
              (itemView && itemView === true) ||
              user.roles[0].role.name === 'Vendor' ||
              user.roles[0].role.name === 'Service Provider' ||
              user.roles[0].role.name === 'Realtor' ? null : (
                <Button
                  color="teal"
                  label={'Add ' + variables.serviceRequest}
                  onClick={() => onSetServiceRequestFormIsVisible(true)}
                  icon={<Icon glyph="inbox-in" weight="light" size="small" />}
                  size="small"
                />
              )
            }
            image={
              <img
                alt={`Your ${variables.serviceRequest} inbox is empty`}
                src="/assets/empty/service-requests.svg"
              />
            }
          />
        )}
        <Overlay
          showOverlay={serviceRequestFormIsVisible}
          content={
            <ServiceRequestForm
              propertyDisabled={this.props.propertyDisabled}
              serviceRequest={serviceRequest}
              from={from}
            />
          }
        />
        <Overlay
          showOverlay={this.state.showOverlay}
          content={
            <ServiceRequestAssignForm
              from={from}
              serviceRequest={
                this.state.isGroupSelected
                  ? this.state.selectedSrsGroupId[0]
                  : this.state.overlayServiceRequest[0]
              }
              onClose={() => this.setState({ showOverlay: false })}
              handleStatusChange={this.handleStatus.bind(this)}
              isLegacyTable={true}
            />
          }
        />
        {this.state.showPopup ? (
          <Popup onSubmitPopup={this.onSubmitPopup} />
        ) : null}
        {this.state.openServiceRequestModal ? (
          <Modal
            open={this.state.openServiceRequestModal}
            modal
            onClose={() =>
              this.setState({
                openServiceRequestModal: false,
                selectedGroupId: '',
              })
            }
          >
            <div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ textAlign: 'right' }}>
                  <div className="filters_modal_top_coner_box">
                    <div
                      className="filters_modal_close_icon"
                      onClick={() =>
                        this.setState({
                          openServiceRequestModal: false,
                          selectedGroupId: '',
                        })
                      }
                    >
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.96 12.75L19.5 18.29V19.75H18.04L12.5 14.21L6.96 19.75H5.5V18.29L11.04 12.75L5.5 7.21V5.75H6.96L12.5 11.29L18.04 5.75H19.5V7.21L13.96 12.75Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              {this.state.acceptGroupLabelInput ? (
                <>
                  <Input
                    value={this.state.groupLabel}
                    onChange={(e) =>
                      this.setState({ groupLabel: e.target.value })
                    }
                    label="Group Label"
                    placeholder="Enter Group Label.."
                    block
                    required
                    //errors={this.state.errors.firstname}
                  />
                  <Button
                    color="teal"
                    label="Create new group"
                    size="tiny"
                    onClick={() => this.createNewGroup()}
                    disabled={this.state.groupLabel ? false : true}
                  />
                </>
              ) : this.state.showGroupServiceRequest ? (
                <>
                  {this.state.groupServiceRequestObj.map((data) => {
                    return (
                      <div style={{ flexDirection: 'row' }}>
                        <Checkbox
                          checked={
                            this.state.selectedGroupId === data.id
                              ? true
                              : false
                          }
                          name={
                            this.state.selectedGroupId === data.id
                              ? this.state.selectedGroupId
                              : null
                          }
                          value={
                            this.state.selectedGroupId === data.id
                              ? this.state.selectedGroupId
                              : ''
                          }
                          onClick={() => {
                            this.setState({ selectedGroupId: data.id });
                            this.onClickBulkUpdate(data.id, data);
                            this.setState({
                              selectedGroupServiceRequest: data,
                            });
                          }}
                          readOnly
                        />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <span>{data.ticketNumber}</span>
                        <br />
                      </div>
                    );
                  })}
                  <br />
                  <Button
                    color="teal"
                    label={`Add ${variables.serviceRequest}`}
                    size="tiny"
                    onClick={() =>
                      this.addServiceRequestToGroup(this.state.selectedGroupId)
                    }
                    disabled={
                      this.state.selectedGroupServiceRequest === null
                        ? true
                        : false
                    }
                  />
                </>
              ) : (
                <div style={{ alignItems: 'center', padding: 20 }}>
                  <Button
                    color="teal"
                    label="Create new group"
                    size="tiny"
                    onClick={() =>
                      this.setState({ acceptGroupLabelInput: true })
                    }
                  />
                  <br />
                  <br />
                  <Button
                    color="teal"
                    label="Add to existing group"
                    size="tiny"
                    onClick={() =>
                      this.setState({ showGroupServiceRequest: true })
                    }
                  />
                </div>
              )}
            </div>
          </Modal>
        ) : null}

        {this.state.openDownloadModal ? (
          <Modal
            open={this.state.openDownloadModal}
            modal
            onClose={() => this.setState({ openDownloadModal: false })}
          >
            <div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ textAlign: 'right' }}>
                  <div className="filters_modal_top_coner_box">
                    <div
                      className="filters_modal_close_icon"
                      onClick={() =>
                        this.setState({ openDownloadModal: false })
                      }
                    >
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.96 12.75L19.5 18.29V19.75H18.04L12.5 14.21L6.96 19.75H5.5V18.29L11.04 12.75L5.5 7.21V5.75H6.96L12.5 11.29L18.04 5.75H19.5V7.21L13.96 12.75Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <br />

              <Button
                color="teal"
                label="CSV download"
                size="tiny"
                onClick={() => this.download()}
              />
              <br />
              <br />

              <Button
                color="teal"
                label="PDF download"
                size="tiny"
                onClick={() => this.downloadPDF()}
              />
            </div>
          </Modal>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  paginationCount: state.paginationCount.count,
  pageCount: state.serviceRequestStatusPageCount.pageCount,
  serviceRequests: selectServiceRequests(state),
  serviceRequestByGroup: state.serviceRequestsByGroup.serviceRequestByGroup,
  serviceRequestByGroupIndex: state.serviceRequestsByGroup.indexID,
  displayClosedAndResolvedTickets:
    state.serviceRequestsByGroup.displayClosedAndResolvedTickets,
  serviceRequestFormIsVisible: selectServiceRequestFormIsVisible(state),
  search: selectSearch(state),
  user: selectAuthenticatedUser(state),
  loader: selectLoader(state),
  formLoader: selectFormLoader(state),
  csvExportLoading: state.csvExport.loading,
  csvExportDownloadedServiceRequestList: state.csvExport.serviceRequestList,
  csvLoadingDone: state.csvExport.loadingDone,
  properties: selectProperties(state),
  issueTypes: state.formOptions.types,
  items: selectItems(state),
  buildingsList: state.buildings,
  levelsList: state.levels,
  filterQuery: state.Filter,
  filterServiceProviderandPropertyDeveloperList:
    state.FilterServiceProviderandPropertyDeveloperList.payload,
  propertySuites: selectSuites(state),
  ticketStatus: state.formOptions.ticketStatus,
  selectedPropertyCommonAreas:
    state.FilterCommonAreas.selectedPropertyCommonAreas,
  fetchedPropertyCommonAreas:
    state.FilterCommonAreas.fetchedPropertyCommonAreas,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onSetServiceRequestFormIsVisible: setServiceRequestFormIsVisible,
      updateBulkStatus: updateBulkStatus,
      onfetchAllTicketStatus: fetchAllTicketStatus,
      createServiceRequestByGroup: createServiceRequestByGroup,
      setCurrentGroupServiceRequestIndex: setCurrentGroupServiceRequestIndex,
      setDisplayClosedAndResolvedTickets: setDisplayClosedAndResolvedTickets,
      deleteServiceRequestFromGroup: deleteServiceRequestFromGroup,
      deleteServiceRequestGroup: deleteServiceRequestGroup,
      addFilterQuery: addFilterQuery,
      getPropertyBuildings: getPropertyBuildings,
      getBuildingLevels: getBuildingLevels,
      clearLoadingDownloadServiceRequestList,
      onFetchPropertySuites: fetchPropertySuites,
      onFetchFilteredServiceRequestByStatusAndDays:
        fetchfilteredServiceRequestByStatusAndDays,
      fetchGroupServiceRequest: fetchGroupServiceRequest,
      clearServiceRequestByGroup: clearServiceRequestByGroup,
      clearSuites,
      fetchPropertyCommonAreas,
      clearSelectedPropertyCommonAreas,
      selectPropertyCommonAreasForFilterDone,
      fetchSelectedServiceRequestCSVExportDownloadList,
      fetchSelectedServiceRequestPDFExportDownloadList,
      onFetchIssueTypes: fetchAllIssueTypes,
      onExitServiceRequestForm: exitServiceRequestForm,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceRequestsTable);
